module.exports = __webpack_public_path__ + "media/images/bnr-early-lg-da4839478f269d724903d0f5963e49e0.png";